import { render, staticRenderFns } from "./CustomerField.vue?vue&type=template&id=068a0434&"
import script from "./CustomerField.vue?vue&type=script&lang=js&"
export * from "./CustomerField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports